import $http from '@/plugins/axios'
import $const from '@/utils/const'
import AppService from '@/services/app.service'

const statusColorMap = {
    canceled: '#B7BF40',
    completed: '#42BE80',
    active: '#1980EF',
    waiting: '#FF5F5F',
    draft: '#919191'
}

const SaleService = {
    searchUser (keyword, pagination) {
        let str = ''
        str += '&page=' + pagination.page
        str += '&page_size=' + pagination.rowsPerPage
        return $http.get('/sale/users/?search=' + keyword + str)
    },
    getUser (userId) {
        return $http.get('/sale/users/' + userId)
    },
    getUserProjects (userId) {
        return $http.get('/sale/users/' + userId + '/projects/')
    },
    getSaleApis (userId) {
        return $http.get('/sale/apis/')
    },
    mapFiltersPackage (filters, pagination) {
        let str = ''
        str += 'project_api__project=' + (filters.project ? filters.project : '')
        str += '&project_api__api=' + (filters.api ? filters.api : '')
        str += '&limit_type=' + (filters.type ? filters.type : '')
        str += '&status=' + (filters.status ? filters.status : '')
        str += '&include_canceled=' + (filters.viewCanceled ? 1 : 0)
        str += '&' + AppService.mapPagination(pagination)
        return str
    },
    searchPackage (userId, filters, pagination) {
        return $http.get(`/sale/users/${userId}/post-paid-package/?` + this.mapFiltersPackage(filters, pagination))
    },
    getPackage (userId, packageId) {
        return $http.get('/sale/users/' + userId + '/post-paid-package/' + packageId + '/')
    },
    mapModelToData (model) {
        let data = {
            name: model.name,
            api_id: model.apiId,
            limit_type: model.type,
            project_name: model.projectName ? model.projectName : '',
            project_id: model.projectId ? model.projectId : '',
            config: {
                limit: Number(model.limit)
            },
            start_time: model.startTime,
            end_time: model.endTime
        }
        if (data.limit_type === $const.LIMIT_USAGE) {
            data.config.unit_price = [{
                start: 1,
                price: Number(model.unitPrice),
                unit: 'vnd'
            }]
        } else {
            data.config.unit_price = model.unitStepPrice
        }
        data.config = JSON.stringify(data.config)
        return data
    },
    savePackage (userId, model, isDraft = false) {
        let data = this.mapModelToData(model)
        if (isDraft) {
            data.status = $const.DRAFT
        } else {
            data.status = $const.WAITING
        }
        return $http.post('/sale/users/' + userId + '/post-paid-package/', data)
    },
    editPackage (userId, model, packageItem) {
        let data = this.mapModelToData(model)
        data.status = packageItem.status
        return $http.put('/sale/users/' + userId + '/post-paid-package/' + packageItem.id + '/', data)
    },
    deletePackage (userId, packageItem) {
        return $http.delete('/sale/users/' + userId + '/post-paid-package/' + packageItem.id + '/')
    },
    changeStatusPackage (userId, packageItem) {
        let item = JSON.parse(JSON.stringify(packageItem))
        item.config = JSON.stringify(item.config)
        item.api_id = item.project_api.api_id
        item.project_id = item.project_api.project_id
        return $http.put('/sale/users/' + userId + '/post-paid-package/' + item.id + '/', item)
    },
    getPackageStatusColor (status) {
        return statusColorMap[status] ? statusColorMap[status] : ''
    },
    calculatePrice (amount, unitPrice) {
        if (!Array.isArray(unitPrice) || unitPrice.length < 1) {
            return null
        }
        amount = Number(amount)
        for (let i = 0; i < unitPrice.length; i++) {
            let unit = unitPrice[i]
            unit.start = Number(unit.start)
            unit.price = Number(unit.price)
        }
        let chopList = []
        for (let i = 0; i < unitPrice.length; i++) {
            let unit = unitPrice[i]
            let unitNext = i < unitPrice.length - 1 ? unitPrice[i + 1] : null
            if (unitNext) {
                if (amount >= unitNext.start) {
                    chopList.push(unitNext.start - unit.start)
                } else {
                    chopList.push(amount - unit.start + 1)
                    break
                }
            } else {
                chopList.push(amount - unit.start + 1)
                break
            }
        }
        let sum = 0
        for (let i = 0; i < chopList.length; i++) {
            sum += chopList[i] * Number(unitPrice[i].price)
        }
        return sum
    }
}

export default SaleService
